import { Modal } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { reportCoachMarks } from '../../analytics';
import useBreakpoint, { SIZE_XS } from '../../hooks/useBreakpoint';
import styles from './adminWelcomeModal.module.scss';
import { PLATFORM_TOUR_SESSION_STORAGE_KEY } from '../../constants';
import {
  runTutorial,
  showPopupReminder,
} from '../../store/shared/platformTourSlice';

export default function AdminWelcomeModal() {
  const bp = useBreakpoint();
  const [show, setShow] = useState(true);
  const dispatch = useDispatch();
  const linkModule = 'cmwelcome';

  const earlyExit = () => {
    if (!sessionStorage.getItem(PLATFORM_TOUR_SESSION_STORAGE_KEY)) {
      dispatch(showPopupReminder());
    }
  };
  const platformTour = () => {
    const a: HTMLAnchorElement = document.querySelector(
      'button.helpGuide-startCoachMarkTour',
    ) as HTMLAnchorElement;
    if (a) {
      setShow(false);
      dispatch(runTutorial());
    }
  };
  useEffect(() => {
    setTimeout(() => {
      const closeBtn: HTMLButtonElement = document.querySelector(
        '.dsm-modal__close-container button',
      ) as HTMLButtonElement;
      if (closeBtn) {
        closeBtn.tabIndex = -1;
        closeBtn.blur();
      }
    }, 1);
  }, []);

  if (bp === SIZE_XS) {
    return null;
  }
  return (
    <Modal
      show={show}
      analyticsRegion={{ 'data-adoberegion': linkModule }}
      title="Welcome to your PMI Partner Platform"
      variant="dialog"
      onClose={() => {
        setShow(false);
        earlyExit();
        reportCoachMarks('Close', linkModule);
      }}
      customClassName={styles.adminWelcomeModal}
      buttons={[
        {
          titleText: 'I’ll explore myself',
          variant: 'outline-secondary',
          size: 'sm',
          onClick: () => {
            setShow(false);
            earlyExit();
            reportCoachMarks('I’ll explore myself', linkModule);
          },
          enforceTitleCase: false,
        },
        {
          titleText: 'Take a quick tour',
          size: 'sm',
          onClick: () => {
            platformTour();
            reportCoachMarks('Take a quick tour', linkModule);
          },
          enforceTitleCase: false,
        },
      ]}
    >
      <div className={styles.adminWelcomeModalContent}>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <p className="px-3">
          The partner platform is your central hub for managing your training
          program with PMI. From inviting users to tracking progress and
          spending, these tools will help you deliver an effective and seamless
          experience for your learners.
        </p>
      </div>
    </Modal>
  );
}
